export default __webpack_public_path__ + "static/media/Vespa1.cd9b949e.jpg";